<template>
  <div style="transition: 0.4s;" class="w-1/4 bg-white rounded-xl space-y-6 p-6 tip-block" :class="`step${ nowStep }`">
    <img :src="require('@/assets/cat.png')" />
    <!-- <p>
      恭喜您距離完成行銷計畫又前進了一大步！現在請點選下一步繼續進行填寫吧！
    </p> -->
    <p v-html="content"></p>
    <!--<div class="tip-footer">
      <button
        v-if="nowStep === 0"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        開始教學
      </button>
    </div>-->
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/nextSectionTips.json';

export default {
  name: 'NextSectionTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          message = data[0].content_zh_TW;
        }
        if(this.selectLang == 'en-US'){
          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    }
  }
};

</script>

<style lang="scss" scoped>

img {
  margin: auto;
}

.step999 {
  position: absolute;
  top: calc(100vh - 400px);
  left: 65vw;
}

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}

.tip-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

</style>
